import { createEntityAdapter, createSlice, EntityState } from "@reduxjs/toolkit";
import LicenceModel from "../../models/LicenceModel";
import { createLicence, getLicenceListByLocationId, updateLicence } from "./licenceRequests";

export const licenceAdapter = createEntityAdapter<LicenceModel>({
  selectId: (licence) => licence.id,
  sortComparer: (a, b) => a.name.localeCompare(b.name),
});

type LicenceState = {
  selectedLicenceId: number | null;
} & EntityState<LicenceModel>

const initialState: LicenceState = {
  selectedLicenceId: null,
  ...licenceAdapter.getInitialState(),
}

export const licenceSlice = createSlice({
    name: 'licenceSlice',
    initialState,
    reducers: {
      setCurrentLicenceId: (state, action) => {
        state.selectedLicenceId = action.payload;
      }
    },
    extraReducers: builder =>
      builder
        .addCase(getLicenceListByLocationId.pending, (state, action) => {
          licenceAdapter.removeAll(state);
        })
        .addCase(getLicenceListByLocationId.fulfilled, (state, action) => {
          licenceAdapter.setMany(state, action.payload);
        })
        .addCase(createLicence.fulfilled, (state, action) => {
          licenceAdapter.addOne(state, action.payload);
        })
        .addCase(updateLicence.fulfilled, (state, action) => {
          licenceAdapter.upsertOne(state, action.payload);
        })
  }
);

export const { setCurrentLicenceId } = licenceSlice.actions;